import React, { useEffect, useState } from 'react';
import './landing_page.css'; // Import CSS file for styling
import { motion } from 'framer-motion';
import { SvgComputerMouse } from './svgComponents/SvgComputerMouse.tsx';

const LandingPage = () => {
    const isMobile = window.innerWidth <= 430; // Example breakpoint for mobile devices

    // Define box sizes based on device type
    const boxSize = isMobile ? 100 : 150; 
    
    // Calculate the number of rows and columns based on screen size
    const numRows = Math.ceil(window.innerHeight / boxSize); 
    const numCols = Math.ceil(window.innerWidth / boxSize);

    const [classMap, setClassMap] = useState({}); // State to hold the class names for each box
    const [textMap, setTextMap] = useState({}); // State to hold the text for odd boxes

    // Predefined list of texts for odd boxes
    const texts = [ "ICT", "Office", "Automation", "Software", "Networking", "Communication" ];

    // UseEffect hook to initialize class names and texts for each box
    useEffect(() => {
        const initialClassMap = {};
        const initialTextMap = {};

        for (let i = 0; i < numRows * numCols; i++) {
            initialClassMap[i] = i % 2 === 0 ? 'even' : 'odd'; // Initialize class names
            if (i % 2 !== 0) {
                initialTextMap[i] = texts[Math.floor(Math.random() * texts.length)]; // Assign random text
            }
        }

        setClassMap(initialClassMap);
        setTextMap(initialTextMap);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setClassMap(prevClassMap => {
                const newClassMap = { ...prevClassMap };
                Object.keys(newClassMap).forEach(key => {
                    newClassMap[key] = newClassMap[key] === 'even' ? 'odd' : 'even';
                });
                return newClassMap;
            });

            setTextMap(prevTextMap => {
                const newTextMap = { ...prevTextMap };
                Object.keys(newTextMap).forEach(key => {
                    if (classMap[key] === 'even') {
                        newTextMap[key] = texts[Math.floor(Math.random() * texts.length)];
                    }
                });
                return newTextMap;
            });
        }, 1000); // Toggle class names and update texts every second

        return () => clearInterval(interval); // Clean up the interval when the component unmounts
    }, [classMap]);

    // Generate an array of box elements
    const renderBoxes = () => {
        const boxes = [];
        for (let i = 0; i < numRows * numCols; i++) {
            const className = `box ${classMap[i] || 'even'}`; // Use class name from state or default to 'even'
            const text = classMap[i] === 'even' ? textMap[i] : ''; // Display text only for odd boxes

            boxes.push(
                <div key={i} className={className}>
                    {text}
                </div>
            );
        }
        return boxes;
    };

    return (
        <motion.div className="landing-page" style={{ overflow: 'hidden' }}>
            <motion.div
                className="landing-text"
                initial={{ opacity: 1 }}
                animate={{ opacity: 0 }}
                transition={{ duration: 0.5, delay: 3, ease: [0.87, 0, 0.13, 1] }}
            >
                netconn engineering
            </motion.div>
            {renderBoxes()}
            <motion.div className="mouse-container">
                <SvgComputerMouse />
            </motion.div>
        </motion.div>
    );
};

export default LandingPage;
